import { Component, OnInit } from '@angular/core';
import { RelatorioDTO } from 'src/app/entity/relatorio/RelatorioDTO';
import { RelatorioService } from 'src/app/service/relatorio/relatorio.service';
import { FiltroManifestoPorTemaDTO } from 'src/app/entity/relatorio/manifestoPorTema/FiltroManifestoPorTemaDTO';
import { ManifestoPorTemaDTO } from 'src/app/entity/relatorio/manifestoPorTema/ManifestoPorTemaDTO';
import { ERRO_GERACAO_ARQUIVO } from 'src/app/tools/Mensagens';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';

import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { AssuntoService } from 'src/app/service/assunto/assunto.service';
import { ClassificacaoService } from 'src/app/service/classificacao/classificacao.service';

const MAX_PAGE = 10;
const MAX_PAGINACAO = 5;

@Component({
  selector: 'manifesto-por-tema',
  templateUrl: './manifesto-por-tema.component.html',
  styleUrls: ['./manifesto-por-tema.component.css']
})
export class ManifestoPorTemaComponent implements OnInit {

  count = 10;
  pages: Array<number>;
  filtro: FiltroManifestoPorTemaDTO;
  relatorio: RelatorioDTO<ManifestoPorTemaDTO>;
  listaStatus: any[];
  //listaAssuntos: string[];
  listaAssuntos: any[];
  listaClassificacoes: any[];
  listaUnidades: string[];
  //listaUnidades: any[];
  //listaManifestos: string[];
  listaManifestos: any[];

  listaTemas: string[];
  manifestoSelecionado: any;
  assuntoSelecionado;

  checkedPrimeiraInstancia: boolean = false;



  manifestoEnum: any;
  MAX_PAGINACAO = MAX_PAGINACAO;

  constructor(
    private relatorioService: RelatorioService,
    private manifestoService: ManifestoService,
    private assuntoService: AssuntoService,
    private classificacaoService: ClassificacaoService
    ) {

    this.filtro = new FiltroManifestoPorTemaDTO();
    this.manifestoEnum = MANIFESTO_ENUM;

  }

  ngOnInit() {

    this.count = 10;
    //this.findAll(this.filtro);
    this.relatorio = new RelatorioDTO();

    this.relatorioService.listarUnidades()
    .subscribe((listaUnidades: string[]) => this.listaUnidades = listaUnidades,
    err => alert(err.error.message));


    this.manifestoService.carregarDados().subscribe(manifestos => {

      this.listaManifestos = manifestos.filter(manifesto => manifesto.numeroOrdem !== '1').sort((a, b) => {

        const aEnumKey = Object.keys(this.manifestoEnum).find(key => this.manifestoEnum[key].id === a.id);
        const bEnumKey = Object.keys(this.manifestoEnum).find(key => this.manifestoEnum[key].id === b.id);

        return this.manifestoEnum[aEnumKey].ordem - this.manifestoEnum[bEnumKey].ordem;

      });

    });


  }


  get paginacaoRegistros() {

    let maxPagina = (this.filtro.page + 1) * MAX_PAGE;

    if (maxPagina > this.relatorio.total) {

      maxPagina = this.relatorio.total;

    }

    return this.filtro.page * MAX_PAGE + 1 + ' - ' + maxPagina + ' de ' + this.relatorio.total + ' registros';

  }

  setNextPage(event: any) {

    event.preventDefault();

    if (this.filtro.page + 1 < this.pages.length) {

      this.filtro.page = this.filtro.page + 1;
      this.findAll(this.filtro);

    }

  }

  clean(event: any) {

    event.preventDefault();
    this.filtro = new FiltroManifestoPorTemaDTO();
    this.findAll(this.filtro);

  }

  get filtroDesabilitado() {

    return !this.filtro.dataInicial || !this.filtro.dataFinal || this.filtro.dataInicial === 'null' || this.filtro.dataFinal === 'null';

  }

  gerarPdf() {

    this.relatorioService.gerarPdfManifestosPorTema(this.filtro)
    .subscribe(pdf => {

      const blob = new Blob([pdf], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'arquivo.pdf';
      link.click();

    }, () => alert(ERRO_GERACAO_ARQUIVO));

  }

  gerarCsv() {

    this.relatorioService.gerarCsvManifestosPorTema(this.filtro)
    .subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'arquivo.csv';
      link.click();

    }, err => alert(JSON.parse(err.error).message));

  }

  filter(event: any) {

    event.preventDefault();
    this.filtro.page = 0;
    this.count = 10;
    this.findAll(this.filtro);

  }

  exibePagina(index) {

    return (index < (this.filtro.page + MAX_PAGINACAO) && (index >= this.filtro.page || index >= (this.pages.length - MAX_PAGINACAO))) ||
            (MAX_PAGINACAO > this.pages.length);

  }

  setFirstPage(event: any) {

    event.preventDefault();

    this.filtro.page = 0;
    this.findAll(this.filtro);

  }

  setLastPage(event: any) {

    event.preventDefault();

    this.filtro.page = this.relatorio.total % MAX_PAGE === 0 ?
                        this.relatorio.total / MAX_PAGE - 1 :
                        Math.trunc(this.relatorio.total / MAX_PAGE);
    this.findAll(this.filtro);

  }

  setPreviousPage(event: any) {

    event.preventDefault();

    if (this.filtro.page > 0) {

      this.filtro.page = this.filtro.page - 1;
      this.findAll(this.filtro);

    }

  }

  setPage(i, event: any) {

    event.preventDefault();

    this.filtro.page = i;
    this.findAll(this.filtro);

  }

  findAll(filtro: FiltroManifestoPorTemaDTO) {

    this.relatorioService.filtroRelatorioManifestosPorTema(filtro)
    .subscribe((resultado: RelatorioDTO<ManifestoPorTemaDTO>) => {

      this.relatorio.manifestos = resultado.manifestos;
      this.relatorio.total = resultado.total;
      this.relatorio.totalPaginado = resultado.totalPaginado;

      const totalPaginas = this.relatorio.total % MAX_PAGE === 0 ?
                                          this.relatorio.total / MAX_PAGE :
                                          Math.trunc(this.relatorio.total / MAX_PAGE) + 1;

      this.pages = new Array(totalPaginas);

    }, err => alert(err.error.message));

  }

  dataHoraFormat(dataHora) {

    if (dataHora) {

      const m = new Date(dataHora);
      dataHora = ('0' + m.getUTCDate()).slice(-2) + '/' + ('0' + (m.getUTCMonth() + 1 )).slice(-2) + '/' + m.getUTCFullYear() + ' ' +
      ('0' + m.getUTCHours()).slice(-2) + ':' + ('0' + m.getUTCMinutes()).slice(-2) + ':' + ('0' + m.getUTCSeconds()).slice(-2);

    }

    return dataHora;

  }

  dataFormat(data) {

    if (data) {

      const m = new Date(data);
      data = ('0' + m.getUTCDate()).slice(-2) + '/' + ('0' + (m.getUTCMonth() + 1 )).slice(-2) + '/' + m.getUTCFullYear();

    }

    return data;

  }

  manifestoEscolhido() {

      this.listaAssuntos = [];
      this.assuntoSelecionado = null;
      this.assuntoService.carregarAssuntosPorManifesto(this.manifestoSelecionado).subscribe(assuntos => this.listaAssuntos = assuntos);

      this.filtro.tipoManifesto = this.manifestoSelecionado.nomeManifesto;

  }


  assuntoEscolhido() {

    this.classificacaoService.carregarClassificacoesPorAssunto(this.assuntoSelecionado).subscribe(classificacoes => this.listaClassificacoes = classificacoes);

    this.filtro.assunto = this.assuntoSelecionado.descricao;
  }


  tipoJusticaEscolhido(event: any){

    if(event.target.value === '1' && this.manifestoSelecionado.nomeManifesto === 'Reclamação'){
        this.checkedPrimeiraInstancia = true;
    }
    else{
        this.checkedPrimeiraInstancia = false;
    }

  }



}
